import { OnInit, OnDestroy, Component, EventEmitter, Input, Output, ViewChild, TemplateRef } from "@angular/core";
import { ComponentSource, ModalType } from "../../models/component-source";
import { ModalManagerService } from "../../services/modal-manager.service";
import { SharedActions } from "../../shared.actions";
import { select } from "@angular-redux/store";
import { Subject, Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { PlanningBlock } from "../../../pb-screen/models/planning-block/planning-block.interface";
import { SharedService } from "../../services/shared.service";
import { ApplicationUser } from "../../../pb-screen/models/application.user.interface";

@Component({
  selector: "planningblock-reservation-modal",
  templateUrl: "./planningblock-reservation-modal.component.html",
})

export class PlanningBlockReservationComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild("dateTemplate") public dateTemplate: TemplateRef<any>;
  @Input()
  public source: string;
  @Output() public closed = new EventEmitter<void>();
  public selectedFileNumber: string = null;

  @select("uiState") public uiState$: Observable<boolean[]>;
  @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
  public enableAutocomplete: boolean = false;

  public columns = [];
  public uiState: boolean[];
  public modalType = ModalType;
  public selectedPlanningBlocks: PlanningBlock[] = [];
  public componentSource = ComponentSource;
  public planningBlocks: PlanningBlock[] = [];
  public planningBlocksCount: number = 0;

  ngOnInit(): void {
    this.uiState$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((uiState: boolean[]) => {
      this.uiState = uiState;
    });

    this.applicationUser$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((applicationUser: ApplicationUser) => {
      if (applicationUser) {
        this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
      }
    });

    this.columns = ["Truck", "Driver", "Haulier", "Container Type", "Pb Status"];
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  constructor(
    private readonly modalManager: ModalManagerService,
    private readonly sharedActions: SharedActions,
    private readonly sharedService: SharedService
  ) {
  }

  public open(selectedPlanningBlocks: PlanningBlock[]): void {
    this.selectedPlanningBlocks = selectedPlanningBlocks || [];
    this.selectedFileNumber = this.selectedPlanningBlocks.length > 0 ? this.selectedPlanningBlocks[0].fileId : null;
    this.planningBlocks = [];
    this.planningBlocksCount = 0;
    this.modalManager.openModal(this.modalType.reservation);

    if (!this.selectedFileNumber) {
      return;
    }

    this.sharedService.getPlanningBlocksByFileNumber(this.selectedFileNumber.toString()).pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      (result: PlanningBlock[]) => {
        this.planningBlocks = result || [];
        this.planningBlocksCount = this.planningBlocks.length;
      }, (error) => {
        console.log(error);
      });
  }

  public closeModal(): void {
    this.modalManager.closeModal(this.modalType.reservation);
    this.sharedActions.setUiState(true);
    setTimeout(() => this.closed.emit(), 500);
  }
}
